import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { makeGet } from '../../api/ajax';
import { routes } from '../../routes/Routes';
import { MenuPage } from '../../layouts';
import { PageTitle, SettingsSummary } from '../../components';
import { actions as customerConfigurationsActions, selectors as customerConfigurationsSelectors } from '../../redux/customerConfigurations';

import MfaModal from './containers/MfaModal/MfaModal';

const Settings = () => {
  const [currentUser, setCurrentUser] = useState(null);
  const [showMfaModal, setShowMfaModal] = useState(false);

  const dispatch = useDispatch();
  const customerConfiguration = useSelector(customerConfigurationsSelectors.selectCustomerConfiguration);

  useEffect(() => {
    makeGet('users/me').subscribe(({ response }) => setCurrentUser(response));
  }, []);

  useEffect(() => {
    if (customerConfiguration) return;

    makeGet('customerConfigurations/current').subscribe(({ response }) => {
      dispatch(customerConfigurationsActions.loadCurrentCustomerConfigurationSuccess(response));
    });
  }, [customerConfiguration, dispatch]);

  if (!currentUser || !customerConfiguration) return null;

  const mfaEnforcedByCustomer = customerConfiguration.mfaEnabled;
  const mfaEnabled = mfaEnforcedByCustomer || currentUser.mfaEnabled;

  return (
    <MenuPage currentRoute={routes.settings}>
      <PageTitle>
        <PageTitle.Left headingText="Settings" />
      </PageTitle>

      <div className="row">
        <div className="col-sm-6">
          <SettingsSummary
            title="Multi-factor authentication"
            tooltipTitle={
              mfaEnforcedByCustomer
                ? 'MFA is enforced for all users by your customer\'s account settings and cannot be changed here'
                : undefined
            }
            testId="mfaEditBtn"
            content={mfaEnabled ? 'On' : 'Off'}
            onEditClick={mfaEnforcedByCustomer ? undefined : () => setShowMfaModal(true)}
          />
        </div>
      </div>

      {showMfaModal && (
        <MfaModal
          show={showMfaModal}
          mfaEnabled={currentUser.mfaEnabled}
          onModalClose={() => setShowMfaModal(false)}
          onUpdated={(updatedUser) => setCurrentUser(updatedUser)}
        />
      )}
    </MenuPage>
  );
};

export default Settings;
